import styled from 'styled-components';

export const DropZoneContainer = styled.section`
  padding: 4px;
  border: 1px dashed #ccc;
`;

export const DropZoneTitle = styled.div`
  text-align: center;
  font-weight: 600;
`;
